import type { FC, PropsWithChildren } from 'react';
import { Box } from 'braid-design-system';
import { IconCertifiedWithIntercom } from '../IconCertifiedWithIntercom';
import CustomTag from 'src/components/common/CustomTag/CustomTag';
import * as styles from './VerifiedTag.css';
import type { RegularOrSmall } from '../types';

type VerifiedTagProps = {
  size?: RegularOrSmall;
} & PropsWithChildren;

const VerifiedTag: FC<VerifiedTagProps> = ({ children, size }) => (
  <CustomTag size={size}>
    <Box paddingRight="xxsmall">
      <IconCertifiedWithIntercom />
    </Box>
    <Box className={styles.truncate}>{children}</Box>
  </CustomTag>
);

export default VerifiedTag;
